import React      from 'react';
import classnames from 'classnames';

import InstantQuote         from 'pu-react/components/InstantQuote';
import Quantities           from 'pu-react/components/Quantities';
import BomLineItems         from 'pu-react/components/BomLineItems';
import SmtPlacements        from 'pu-react/components/SmtPlacements';
import ThruHolePlacements   from 'pu-react/components/ThruHolePlacements';
import BgaPlacements        from 'pu-react/components/BgaPlacements';
import QfnPlacements        from 'pu-react/components/QfnPlacements';
import DoubleSideSMT        from 'pu-react/components/DoubleSideSMT';
import LeadFreeProcessing   from 'pu-react/components/LeadFreeProcessing';
import Class3Inspection     from 'pu-react/components/Class3Inspection';

import SupplierSelected     from 'pu-react/components/SupplierSelected';
import RowSelected          from 'pu-react/components/RowSelected';
import ColumnSelected       from 'pu-react/components/ColumnSelected';

import ProductQuoteNumber   from 'pu-react/components/ProductQuoteNumber';
import RequiredInformation  from 'pu-react/components/RequiredInformation';

import HiddenInput          from 'pu-react/components/base/HiddenInput';
import ErrorLabel           from 'pu-react/components/base/ErrorLabel';

export default (props) => {
  const { itemId, currentVariant } = props
  const classFormSection = classnames('pcb-form-section', { 'd-none': props.showSummary });
  const onChange = props.onChangeParameter;
  const groupName = `items[${props.itemId}][parameters]`

  const propsPrm = {
    parameters: props.parameters,
    onChangeParameter: props.onChangeParameter,
    groupName,
  }

  const { errors } = props

  return (
    <div className={classFormSection}>
      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...propsPrm}
            label="Board Quantities"
            groupName={`${groupName}[quantities]`}
            error={errors.quantities} />
        </div>
        <div className="col-md-12">
          <BomLineItems
            {...propsPrm}
            error={errors.bom_line_items} />
        </div>
      </div>
      <div className="form-section-border" />

      <div className="placements form-section-border">
        <strong>PLACEMENTS</strong>
        <div className="row">
          <div className="col-md-3 right-padding">
            <SmtPlacements
              {...propsPrm}
              error={errors.smt} />
          </div>
          <div className="col-md-3 left-padding right-padding">
            <ThruHolePlacements
              {...propsPrm}
              error={errors.thru_hole} />
          </div>
          <div className="col-md-3 left-padding right-padding">
            <BgaPlacements
              {...propsPrm}
              error={errors.bga} />
          </div>
          <div className="col-md-3 left-padding">
            <QfnPlacements
              {...propsPrm}
              error={errors.qfn} />
          </div>
        </div>
        <ErrorLabel error={errors.placements} />
      </div>

      <div className="row">
        <div className="col-md-12">
          <LeadFreeProcessing {...propsPrm} />
        </div>
        <div className="col-md-12">
          <DoubleSideSMT {...propsPrm} />
        </div>
        <div className="col-md-12">
          <Class3Inspection {...propsPrm} />
        </div>
      </div>

      <div>
        <RowSelected {...propsPrm} />
        <ColumnSelected {...propsPrm} />
        <SupplierSelected {...propsPrm} />
        <ProductQuoteNumber {...propsPrm} />
        <HiddenInput name="fine_pitch" groupName={groupName} value="0" />
        <HiddenInput
          name="part_number"
          groupName={groupName}
          value={props.parameters.part_number || ''}
          onChange={(e) => onChange('part_number', e.target.value)} />
        <HiddenInput
          name="revision"
          groupName={groupName}
          value={props.parameters.revision || ''}
          onChange={(e) => onChange('revision', e.target.value)} />
        <HiddenInput name="quantity" groupName={groupName} value="1" />
        <HiddenInput
          name="item_selected"
          groupName={groupName}
          value={props.itemSelected} />
        <HiddenInput
          name="variant_id"
          groupName={`items[${itemId}]`}
          value={currentVariant} />
      </div>

      <div className="row">
        <div className="col-md-6">
          <RequiredInformation />
        </div>
        <div className="col-md-6">
          <InstantQuote
            className="btn btn-block btn-blue"
            onClick={props.onRequestQuote} />
        </div>
      </div>
    </div>
  );
};
